import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getConfigUsagePlatforms,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UsagePrepaidAverageConsumptionSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportUsagePrepaidAverageConsumption, sortUsagePrepaidAverageConsumption } from '../../constants';
import {
  getUsageAverageConsumptionReport,
  getAllUsageAverageConsumptionReport,
  onResetDefaultData,
} from '../../actions';
import { makeGetUsageAverageConsumptionReport, makeGetListAllUsageAverageConsumptionReport } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UsagePrepaidAverageConsumption extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUsagePrepaidAverageConsumption: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUsagePrepaidAverageConsumption: props.listUsagePrepaidAverageConsumption,
      totalCount: getPageTotalCount({ ...state, items: props.listUsagePrepaidAverageConsumption }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetUsageAverageConsumptionReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetUsageAverageConsumptionReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listAllUsageAverageConsumptionReport');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListUsagePrepaidAverageConsumption();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListUsagePrepaidAverageConsumption());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListUsagePrepaidAverageConsumption());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListUsagePrepaidAverageConsumption();
    });
  };

  doGetListUsagePrepaidAverageConsumption = () => {
    const { filter, page, size, sorted } = this.state;
    const { getUsageAverageConsumptionReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.usagePeriod) {
      newFilter.usagePeriod = moment().format('YYYY-MM');
    }
    if (!newFilter.percent) {
      newFilter.percent = '0';
    }
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortUsagePrepaidAverageConsumption[sorted.sortCol]
          ? sortUsagePrepaidAverageConsumption[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getUsageAverageConsumptionReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUsagePrepaidAverageConsumption = cb => {
    const { filter, sorted } = this.state;
    const { getAllUsageAverageConsumptionReport } = this.props;
    const newFilter = cloneDeep(filter);

    if (!newFilter.usagePeriod) {
      newFilter.usagePeriod = moment().format('YYYY-MM');
    }
    if (!newFilter.percent) {
      newFilter.percent = '0';
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortUsagePrepaidAverageConsumption[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllUsageAverageConsumptionReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUsagePrepaidAverageConsumption(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUsagePrepaidAverageConsumption, t } = this.props;
        convertJson2Pdf({
          data: listAllUsagePrepaidAverageConsumption,
          t,
          title: t('reportPage:sidebar.prepaidAverageConsumption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.prepaidAverageConsumption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUsagePrepaidAverageConsumption(() => {
      const { listAllUsagePrepaidAverageConsumption, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'USAGE_AVERAGE_CONSUMPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.prepaidAverageConsumption')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.prepaidAverageConsumption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUsagePrepaidAverageConsumption,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUsagePrepaidAverageConsumption,
          t,
          title: t('reportPage:sidebar.prepaidAverageConsumption').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.prepaidAverageConsumption')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.prepaidAverageConsumption')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('USAGE_AVERAGE_CONSUMPTION_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportUsagePrepaidAverageConsumption,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUsagePrepaidAverageConsumption,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUsagePrepaidAverageConsumption,
      t,
      permissions: { modeGetUsageAverageConsumptionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetUsageAverageConsumptionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.prepaidAverageConsumption') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.prepaidAverageConsumption')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UsagePrepaidAverageConsumptionSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.prepaidAverageConsumption').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllUsagePrepaidAverageConsumption,
                          t,
                          title: t('reportPage:sidebar.prepaidAverageConsumption').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.prepaidAverageConsumption')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUsagePrepaidAverageConsumption}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listUsagePrepaidAverageConsumption && listUsagePrepaidAverageConsumption.length
                      ? listUsagePrepaidAverageConsumption
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UsagePrepaidAverageConsumption.propTypes = {
  getUsageAverageConsumptionReport: PropTypes.func,
  getAllUsageAverageConsumptionReport: PropTypes.func,
  listAllUsagePrepaidAverageConsumption: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

UsagePrepaidAverageConsumption.defaultProps = {
  getUsageAverageConsumptionReport: () => {},
  getAllUsageAverageConsumptionReport: () => {},
  listAllUsagePrepaidAverageConsumption: [],
};

const mapStateToProps = createStructuredSelector({
  listUsagePrepaidAverageConsumption: makeGetUsageAverageConsumptionReport() || [],
  listAllUsagePrepaidAverageConsumption: makeGetListAllUsageAverageConsumptionReport() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getUsageAverageConsumptionReport,
    getAllUsageAverageConsumptionReport,
    uploadMultiPartFiles,
    getConfigUsagePlatforms,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(UsagePrepaidAverageConsumption)
);
